const React = require('react');
const ReactDOM = require('react-dom');
const { localStorage } = require('dibs-browser-storage');
const deffered = require('yaDeferred');
require('dibs-trade-onboarding/dist/styles.css');

const abExperiments = require('../../abExperiments.es');
const isTradeUser = require('../../isTradeUser').default;
const User = require('../../models/User');

const LAST_SHOWN_TOKEN = 'last_shown_trade_onboarding_modal';
const type = 'tradeOnboardingModal';

const loadOnboardingModule = function () {
    const onboardingDeferred = deffered();
    require.ensure('dibs-trade-onboarding', () => {
        const { onboardingModal } = require('dibs-trade-onboarding');
        onboardingDeferred.resolve(onboardingModal);
    }, 'dibs-trade-onboarding');

    return onboardingDeferred;
};

const getContainerElement = () => {
    if (window && window.document) {
        const containerElement = document.createElement('div');
        containerElement.classList.add('tradeOnboardingModalContainer');
        document.body.appendChild(containerElement);
        return containerElement;
    } else {
        return null;
    }
};

const hasSeenOnboardingModal = () => {
    return !!localStorage.getItem(LAST_SHOWN_TOKEN);
};

const markModalShown = () => {
    localStorage.setItem(LAST_SHOWN_TOKEN, Date.now());
};

const showTradeOnboardingVariant = () => {
    if (abExperiments.showTradeOnboarding) {
        setTimeout(() => abExperiments.showTradeOnboarding.resolve(false), 1500);
        return abExperiments.showTradeOnboarding;
    } else {
        return Promise.resolve(false);
    }
};

module.exports = function tradeOnboardingRule() {
    const containerElement = getContainerElement();
    if (containerElement && User.loggedIn() && isTradeUser() && !hasSeenOnboardingModal()) {
        return showTradeOnboardingVariant().then(showTradeOnboarding => {
            if (showTradeOnboarding) {
                return loadOnboardingModule().then(onboardingModal => {
                    const { Modal } = onboardingModal({
                        buyerEmail: User.getEmail()
                    });
                    ReactDOM.render(
                        <Modal />,
                        containerElement
                    );
                    markModalShown();
                    return { success: true, type };
                });
            } else {
                return Promise.resolve();
            }
        });
    } else {
        return Promise.resolve();
    }
};



// WEBPACK FOOTER //
// ./assets/js/global/notifications/rules/tradeOnboardingRule.jsx